import React, { useEffect, useMemo, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import plusCircle from "../../../../assets/icons/plusCircle.png";
import { ReactComponent as Spinner } from "../../../../assets/icons/spinner.svg";
import { ReactComponent as LocationPin } from "../../../../assets/icons/find.svg";
import { ReactComponent as Ticket } from "../../../../assets/icons/ticket_sale.svg";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./checkoutForm";
import { useSelector } from "react-redux";
import {
  useStripePaymentIntentMutation, useCreateStripePaymentMutation,
  useUpdateStripePaymentMutation,
  useFinalizeStripePaymentMutation,
} from "../../../../store/Company/companyApiSlice";
import { Modal, LoadingIcon, Button, Input } from "../../../common";
import { BillingAddress } from "../../../common/BillingAddress";
import { AddBillingAddress } from "../../../common/AddBillingAddress";
import { EditBillingAddress } from "../../../common/EditBillingAddress";
import {
  useGetBillingAddressByBillingIdQuery,
  useGetBillingAddressByUserIdQuery, useDeleteBillingAddressMutation
} from "../../../../store/Billing/billingApiSlice";
import { CommonToast } from "../../../common/Toast";
import LottieAnimation from "../../SuccessAnimation";
import { useCallback } from "react";

export const PaymentDetailsForm = ({ setPaymentBreakdown, paymentBreakdown }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { userInfo, token } = useSelector((state) => state.auth);
  const { planDetails: currentPlan } = location.state;
  const { planDetails: company_id } = location.state || {};
  const stateData = location.state;
  const { currentCompanyId: verifyCompanyID } = location.state;
  const [userBillingAddress, setUserBillingAddress] = useState(false);
  const [paymentSuccessfulModal, setPaymentSuccessfulModal] = useState(false);
  const [pendingSetup, setPendingSetup] = useState(false)
  const [clientSecret, setClientSecret] = useState(null);
  const [shippingAd, setshippingAd] = useState([]);
  const [paymentMode, setPaymentMode] = useState(currentPlan?.mode);
  const [openBillingPopup, setOpenBillingPopup] = useState(false);
  const [coupon, setCoupon] = useState("")
  const [couponCode, setCouponCode] = useState("")
  const [deleteBillingAddresss] = useDeleteBillingAddressMutation();
  const [openAddBillingAddressPopup, setOpenAddBillingAddressPopup] =
    useState(false);
  const [openEditBillingAddressPopup, setOpenEditBillingAddressPopup] =
    useState(false);

  const stripePromise = loadStripe(
    process.env.REACT_APP_PUBLIC_STRIPE_PUBLISHABLE_KEY
  );
  const [userID, setUserID] = useState(null);
  const [billingId, setBillingId] = useState("");
  const [showStripePayment, setShowStripePayment] = useState(false);
  const { data, refetch, isLoading: billingAddessLoading } = useGetBillingAddressByUserIdQuery({ id: userID, token });
  const [hasAddressDataChanged, setHasAddressDataChanged] = useState(false)

  useEffect(() => {
    (async function () {
      if (!data || data?.length === 0) {
        setUserBillingAddress(false);
      } else {
        let ShippingAddress = await data ? data.filter((i) => i?.is_primary == true) : [];
        if (await ShippingAddress?.length > 0) {
          setshippingAd(ShippingAddress);
        } else {
          if (data?.length > 0)
            setshippingAd(data)
        }
        setUserBillingAddress(true);
      }
      refetch();
    })();
  }, [data, refetch, hasAddressDataChanged]);

  const appearance = {
    theme: "stripe",
  };
  const options = {
    clientSecret,
    appearance,
  };
  // const [stripePaymentIntent, { isLoading }] = useStripePaymentIntentMutation("");
  const [createStripePayment, { isLoading: isCreateLoading }] = useCreateStripePaymentMutation();
  const [updateStripePayment, { isLoading: isUpdateLoading }] = useUpdateStripePaymentMutation();
  const [finalizeStripePayment, { isLoading: isFinalizeLoading }] = useFinalizeStripePaymentMutation("");

  const filterResult = async () => {
    let result = await data ? data.filter((i) => i?.is_primary == true) : [];
    return result;
  };

  const handlePaymentModalClose = () => {
    setPaymentSuccessfulModal(false);
    navigate("/dashboard/purchased")
  }

  let checkPrimaryAvailable = data ? data.filter((i) => i?.is_primary == true) : data ? data[0] : [];

  const createPaymentEvent = useCallback(async (data) => {
    // let ShippingAddress = await filterResult()
    let ShippingAddress_meta = checkPrimaryAvailable.length > 0 ? checkPrimaryAvailable : data && data
    const metadata_req = {
      createWorldbox: localStorage.getItem("createWorldbox"),
      createWorldBoxCompanyData: localStorage.getItem("createWorldboxCompany"),
      worldboxdata: localStorage.getItem("worldboxData"),
      companyDescription: localStorage.getItem("companyDescription"),
      companyDataString: JSON.parse(localStorage.getItem("payasyougoCompanyID")),
      paycompanyStatus: localStorage.getItem("paycompanyStatus"),
      getActiveOnlySubscription: localStorage.getItem("UpgradePlan"),
      verified: "succes",
      companyforverify: currentPlan?.slug,
      forverifycompid: verifyCompanyID,
      billing_add_ID: ShippingAddress_meta[0]?.billing_add_ID,
      UserID: userInfo?.individual[0]?.userID
    }
    const userid = userInfo?.individual?.[0]?.individualID;
    setUserID(userid);
    try {
      const subscreptionType =
        currentPlan.subsCharge === 275
          ? "PRO"
          : currentPlan.subsCharge === 500
            ? "PREMIUM"
            : currentPlan.subsCharge === 195
              ? "BASIC"
              : currentPlan.subsCharge === 199
                ? "VERIFICATION"
                : 'PAY-AS-YOU-GO';

      const response = await createStripePayment({
        data: {
          recurring: paymentMode === "one-time" ? false : true,
          product_type: subscreptionType,
          promocode: "",
          purchase_track_id: stateData?.purchase_track_id ? stateData.purchase_track_id : "",
          meta_data: metadata_req,
        },
        token: token
      }).unwrap();
      setPaymentBreakdown(response);
      if (stateData.discount_code) {
        setCoupon(stateData.discount_code);
        updatePaymentEvent(response, stateData.discount_code);
      }
    } catch (error) {
      CommonToast.error("Error fetching details");
    }

  }, [currentPlan, verifyCompanyID, userInfo, filterResult, checkPrimaryAvailable, paymentMode, createStripePayment, token]);

  const updatePaymentEvent = async (resData = false, enterpriseCoupon="") => {
    try {
      const response = await updateStripePayment({
        data: {
          invoice_id: resData ? resData?.invoice_id : paymentBreakdown?.invoice_id,
          recurring: resData ? resData?.recurring : paymentBreakdown?.recurring,
          product_type: resData ? resData?.product_type : paymentBreakdown?.product_type,
          promocode: enterpriseCoupon ? enterpriseCoupon : coupon,
          meta_data: resData ? resData?.meta_data_req : paymentBreakdown?.meta_data_req,
        },
        token: token
      }).unwrap();
      setPaymentBreakdown(response);
      if (response?.promocode) {
        setCouponCode(response?.promocode)
      }
    } catch (error) {
      CommonToast.error('Invalid Promo Code')
      console.error("Error fetching client secret:", error);
    }
  };

  useEffect(() => {
    if (data && data.length > 0) {
      createPaymentEvent(data);
    }
  }, [data])

  useEffect(() => {
    const userid = userInfo?.individual?.[0]?.individualID;
    setUserID(userid);
  }, [userInfo]);


  const handleOpenBillingPopup = () => {
    setOpenBillingPopup(!openBillingPopup);
  };
  const handleOpenAddBillingAddressPopup = () => {
    setOpenAddBillingAddressPopup(!openAddBillingAddressPopup);
    setOpenBillingPopup(false);
  };
  const handleOpenEditBillingAddressPopupData = (id) => {
    setBillingId(id);
    setHasAddressDataChanged(!hasAddressDataChanged)
    setOpenEditBillingAddressPopup(!openEditBillingAddressPopup);
    setOpenBillingPopup(false);
  };
  const onClickDelete = async (data) => {
    try {
      const deleteBilling = await deleteBillingAddresss({ data: data, token: token });
      if (deleteBilling) {
        alert("Billing address deleted");
        setHasAddressDataChanged(!hasAddressDataChanged)
        // window.location.reload()
      }
    } catch (error) {
      console.error("Error deleting billing address:", error);

      // Handle the error here, you might want to show a user-friendly message
      alert("Error deleting billing address. Please try again later.");
    }
  }
  const handleOpenEditBillingAddressPopup = () => {
    setOpenEditBillingAddressPopup(!openEditBillingAddressPopup);
    setOpenBillingPopup(false);
  };

  const { data: getExistBilling, refetch: getExistBillingRefetch } =
    useGetBillingAddressByBillingIdQuery({ id: billingId, token });

  const handlePayment = async () => {
    try {
      const finalResponse = await finalizeStripePayment({
        token,
        data: {
          invoice_id: paymentBreakdown?.invoice_id,
          recurring: paymentMode === "one-time" ? false : true,
        }
      });
      if (finalResponse?.data?.client_secret) {
        if (finalResponse?.data?.client_secret === "PAID") {
          setPaymentSuccessfulModal(true)
        } else {
          setClientSecret(finalResponse?.data?.client_secret?.toString());
          setPendingSetup(finalResponse?.data?.pending_setup)
          setShowStripePayment(true)
        }
      } else {
        CommonToast.error("Unable to complete payment")
      }
    } catch (error) {
      CommonToast.error("Unable to complete payment")
    }
  }

  const handleCouponEnter = (e) => {
    const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    setCoupon(sanitizedValue);
  };

  return (
    <>
      <div style={{ width: "793px" }} className="bg-white rounded-md p-4">
        <div>
          <div className="flex justify-between pb-6">
            <div>
              <h3 className="font-semibold sm:text-f24">Billing Details</h3>
            </div>
          </div>
          {userBillingAddress ? (
            <>
              <div>
                <h3 className="font-semibold sm:text-f18  my-4">
                  Billing Address
                </h3>
              </div>
              {data &&
                data?.map(
                  (i) =>
                    i?.is_primary && (
                      <div className="col-span-1 mb-1 edit-bg p-3">
                        <div className="col-span-1 w-full h-full edit-bg2"></div>
                        <div className="flex justify-between items-center">
                          <div className="flex flex-col gap-2.5">
                            <p
                              style={{ fontSize: "14px" }}
                              className="text-[#EBF0F3]"
                            >
                              {i?.companyName || userInfo?.name}
                            </p>
                            <p
                              style={{ fontSize: "14px" }}
                              className="text-[#EBF0F3]"
                            >
                              {i?.mobile}
                            </p>
                            <p
                              style={{ fontSize: "14px" }}
                              className="text-[#EBF0F3]"
                            >
                              {i?.address_line_1} &nbsp;{i?.address_line_2}
                              &nbsp;
                              {i?.city} &nbsp;{i?.postal_code} &nbsp;
                              {i?.country}
                            </p>
                          </div>
                          <button
                            onClick={handleOpenBillingPopup}
                            style={{
                              width: "200px",
                              border: "1px solid rgba(235, 240, 243, 0.40)",
                              background: "rgba(255, 255, 255, 0.20)",
                              fontSize: "14px",
                              zIndex: 1,
                            }}
                            className="bg-white-800 bg-opacity-25 font-semibold text-sm w-28 flex gap-2 items-center justify-center font-sans text-[#EBF0F3] py-2.5 px-4 rounded-md"
                          >
                            Change Address
                          </button>
                        </div>
                      </div>
                    )
                )}
              {checkPrimaryAvailable.length <= 0 && data && (
                <div className="col-span-1 mb-1 edit-bg p-3">
                  <div className="col-span-1 w-full h-full edit-bg2"></div>
                  <div className="flex justify-between items-center">
                    <div className="flex flex-col gap-2.5">
                      <p
                        style={{ fontSize: "14px" }}
                        className="text-[#EBF0F3]"
                      >
                        {data[0]?.companyName || userInfo?.name}
                      </p>
                      <p
                        style={{ fontSize: "14px" }}
                        className="text-[#EBF0F3]"
                      >
                        {data[0]?.country_code} {data[0]?.mobile}
                      </p>
                      <p
                        style={{ fontSize: "14px" }}
                        className="text-[#EBF0F3]"
                      >
                        {data[0]?.address_line_1} &nbsp;{data[0]?.address_line_2}
                        &nbsp;
                        {data[0]?.city} &nbsp;{data[0]?.postal_code} &nbsp;
                        {data[0]?.country}
                      </p>
                    </div>
                    <button
                      onClick={handleOpenBillingPopup}
                      style={{
                        width: "200px",
                        border: "1px solid rgba(235, 240, 243, 0.40)",
                        background: "rgba(255, 255, 255, 0.20)",
                        fontSize: "14px",
                        zIndex: 1,
                      }}
                      className="bg-white-800 bg-opacity-25 font-semibold text-sm w-28 flex gap-2 items-center justify-center font-sans text-[#EBF0F3] py-2.5 px-4 rounded-md"
                    >
                      Change Address
                    </button>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div
              style={{ width: "100%", height: "79px" }}
              className=" w-full  gap-2 my-2 p-4  border-dashed border-2 flex justify-between items-center rounded-md "
            >
              <p>Add New Billing address</p>
              <button
                onClick={handleOpenAddBillingAddressPopup}
                className="bg-primary flex gap-2 items-center justify-center px-4 text-f14 font-sans text-white py-2 rounded-md"
              >
                <img style={{ width: "20px" }} src={plusCircle} alt="plus" />
                Add New Address
              </button>
            </div>
          )}

          {checkPrimaryAvailable.length > 0 ? <div className="bg-white p-8 rounded-md mb-4">
            <h3 className="font-semibold pb-4 text-f18">Order summary</h3>
            {!isCreateLoading && <div className="relative flex w-full h-[42px] justify-between items-center gap-2 mb-2">
              <Input placeholder={"Apply your promo code"} onInputChange={handleCouponEnter} inputvalue={coupon} mZero={true} className={"pl-10"} />
              <div className={"absolute left-3 top-3"}><Ticket /></div>
              <Button disable={isUpdateLoading || showStripePayment} onClick={(isUpdateLoading || showStripePayment) ? null : updatePaymentEvent} classes={`min-w-[100px] h-[42.5px] rounded flex items-center justify-center px-2 py-2 sm:px-3 md:px-6 md:text-f16 text-f12 font-semibold bg-white text-link border border-link ${(isUpdateLoading || showStripePayment) ? "cursor-not-allowed" : "cursor-pointer"}`}>{isUpdateLoading ? <Spinner /> : "Apply"}</Button>
            </div>}
            <hr />
            {isCreateLoading ? <div className="w-full h-[17.2rem] flex justify-center items-center"><Spinner /></div> : <><h4 className="font-semibold py-4">Price Details</h4>

              <div>
                <div className="flex justify-between mb-2">
                  <p className="align-left text-f14">Plan Price</p>
                  <p className="align-left text-f14">${paymentBreakdown?.extra_details.subtotal_excluding_tax ? paymentBreakdown?.extra_details.subtotal_excluding_tax / 100 : 0}</p>
                </div>
                {couponCode && <div className="flex justify-between mb-2">
                  <p className="align-left text-f14">Coupon Discount <span className="font-semibold">{"(" + couponCode + ")"}</span></p>
                  <p className="align-left text-f14 text-[#269758]">-${paymentBreakdown?.extra_details?.total_discount_amounts?.[0]?.amount ? (+paymentBreakdown?.extra_details?.total_discount_amounts?.[0]?.amount) / 100 : 0}</p>
                </div>}
                <div className="flex justify-between mb-2">
                  <p className="align-left text-f14">Taxes</p>
                  <p className="align-left text-f14">${paymentBreakdown?.extra_details.tax ? paymentBreakdown?.extra_details.tax / 100 : 0}</p>
                </div>
              </div>
              <hr />
              <div className="flex justify-between py-2">
                <p className="font-semibold align-left text-f16">Total</p>
                <p className="font-semibold align-left text-f16">${paymentBreakdown?.extra_details.total ? paymentBreakdown?.extra_details.total / 100 : 0}</p>
              </div>
              {/* <p className="text-left text-link font-semibold text-f12">GOT A PROMO CODE? CLICK HERE!</p> */}
              {couponCode && (currentPlan.subsCharge === 275 ||
                currentPlan.subsCharge === 500 ||
                currentPlan.subsCharge === 195) && <p className="text-f10 text-[#3C4848] text-left py-2">
                  Important Notice: The discounted rate applies only to the first month. Standard subscription fees will commence from the second month.
                </p>}
              {!showStripePayment && <Button
                onClick={(isFinalizeLoading || isUpdateLoading) ? null : handlePayment}
                disable={isFinalizeLoading || isUpdateLoading}
                classes={`w-full p-2 ${(isFinalizeLoading || isUpdateLoading) ? "bg-disable cursor-not-allowed" : "bg-primary cursor-pointer"} text-white rounded text-f18 mt-4 flex justify-center items-center`}>
                {isFinalizeLoading ? <Spinner /> : "Pay"}
              </Button>}
            </>}
          </div> : <div className="w-full flex justify-between items-center bg-[#2C5369] p-6 rounded-[8px] text-white">
            <div className="w-[595px] flex flex-col gap-3">
              <p className="text-[24px] font-semibold">Add Your Billing Address</p>
              <p className="text-[16px] font-light">To complete your purchase, please provide a billing address. It’s quick, easy, and ensures smooth processing for your payment.</p>
            </div>
            <LocationPin />
          </div>}
          {showStripePayment && <div className="">
            <div>
              <h3 className="font-semibold my-4 sm:text-f18">
                Select payment method
              </h3>
            </div>
            {!userBillingAddress && <p>Please add billing address to enable payment feature</p>}
            {userBillingAddress && clientSecret && (clientSecret !== "PAID") && data ? (
              <>
                <h4 className="font-semibold sm:text-f16 my-1">Add new card</h4>
                <Elements options={options} stripe={stripePromise}>
                  <CheckoutForm
                    name={userInfo?.name}
                    ShippingAddress={checkPrimaryAvailable.length > 0 ? checkPrimaryAvailable : data && data}
                    clientSecret={clientSecret}
                    pendingSetup={pendingSetup}
                    title={currentPlan?.title}
                    plan={currentPlan}
                    verifycompid={verifyCompanyID}
                  />
                </Elements>
              </>
            ) : userBillingAddress && <LoadingIcon />}
          </div>}
        </div>
      </div>
      {openBillingPopup && (
        <Modal modalHandle={handleOpenBillingPopup}>
          <BillingAddress
            refetch={getExistBillingRefetch}
            addressData={data}
            userName={userInfo?.name}
            handleOpenAddBillingAddressPopup={handleOpenAddBillingAddressPopup}
            onClick={(data) => handleOpenEditBillingAddressPopupData(data)}
            onClickDelete={(data) => onClickDelete(data)}
            setHasAddressDataChanged={setHasAddressDataChanged}
            hasAddressDataChanged={hasAddressDataChanged}
            handleOpenBillingPopup={handleOpenBillingPopup}
          />
        </Modal>
      )}
      {openAddBillingAddressPopup && (
        <Modal
          modalHandle={handleOpenAddBillingAddressPopup}
          billingAddress={"Back"}
        >
          <AddBillingAddress
            refetch={getExistBillingRefetch}
            handleOpenAddBillingAddressPopup={handleOpenAddBillingAddressPopup}
            setHasAddressDataChanged={setHasAddressDataChanged}
            hasAddressDataChanged={hasAddressDataChanged}
          />
        </Modal>
      )}
      {openEditBillingAddressPopup && (
        <Modal
          modalHandle={handleOpenEditBillingAddressPopup}
          billingAddress={"Back"}
        >
          <EditBillingAddress
            setOpenBillingPopup={setOpenBillingPopup}
            data={getExistBilling}
            refetch={getExistBillingRefetch}
            setOpenEditBillingAddressPopup={setOpenEditBillingAddressPopup}
            setHasAddressDataChanged={setHasAddressDataChanged}
            hasAddressDataChanged={hasAddressDataChanged}
          />
        </Modal>
      )}
      {paymentSuccessfulModal && <Modal modalHandle={handlePaymentModalClose}>
        <div className='flex flex-col justify-center items-center w-[500px]'>
          <LottieAnimation />
          <h2 className="text-f24 font-extrabold">Payment Successful</h2>
          <p className="text-secondary text-center">
            Your purchase has been completed
          </p>
          <Button onClick={() => { navigate("/dashboard/purchased") }} classes="w-full p-2 bg-primary text-white rounded text-f18 mt-4 flex justify-center items-center">Return to your Dashboard</Button>
        </div>
      </Modal>}
    </>
  );
};
